export default __webpack_public_path__ + "static/media/w3.95ef8268.png";